import moment from "moment";
class modelEmployed {
  constructor(modelId, name, from, to) {
    this.modelId = modelId;
    this.name = name;
    this.from = moment(from).utc().format("DD-MM-YYYY");
    this.to = to == null ? " " : moment.utc(to).format("DD-MM-YYYY");
  }
  static fromJson({ LiqModeloId, Nombre, FecDesde, FecHasta }) {
    return new modelEmployed(LiqModeloId, Nombre, FecDesde, FecHasta);
  }
}
export default modelEmployed;
